import { createComponentOverrides } from '../theme/create-component-overrides';
export var createMuiBreadcrumbsOverrides = createComponentOverrides(function (_a) {
    var tokens = _a.tokens;
    return ({
        styleOverrides: {
            separator: {
                color: tokens.color_fg_decorative,
                fontSize: '0.875rem',
            },
        },
    });
});
